import { create } from "zustand";
import { persist } from "zustand/middleware";
import { AccountDeletionRequestDto } from "../../api/request/deleteUserAccount";

interface deleteUserAccountState {
  userАccountСhangesInfo: AccountDeletionRequestDto | null;
  setInfo: (user: AccountDeletionRequestDto | null) => void;
  clearInfo: () => void;
}

export const userАccountСhangesStore = create<deleteUserAccountState>()(
  persist(
    (set) => ({
      userАccountСhangesInfo: null,
      setInfo: (info) =>
        set({
          userАccountСhangesInfo: info,
        }),
      clearInfo: () =>
        set({
          userАccountСhangesInfo: null,
        }),
    }),
    {
      name: "user-account-сhanges-info-storage",
    }
  )
);